import createSpacing from '@material-ui/core/styles/createSpacing'

const SPACING = 5

export default createSpacing(SPACING)
